import { Button, CloseButton, Divider, Flex, LoadingOverlay } from "@mantine/core";
import React from "react";
import * as yup from "yup";
import { AdjustmentApi } from "../../apis";
import { HttpHandler } from "../../utils/http-handler";
import { Message } from "../../utils/message";
import { Form } from "../form";
import { CheckboxField } from "../form/checkbox-field";
import { TextField } from "../form/text-field";
import { FormLayout } from "../layout";

const schema = yup.object({
  name: yup.string().max(255, "Хэт урт байна!").required("Заавал бөглөнө!").nullable(),
});

type IFormData = {
  name: string;
  isPublic: boolean;
};

export function AdjustmentNoteForm({ onCancel, action, reload }: { onCancel?: () => void; action: any; reload: () => void }) {
  const [loading, setLoading] = React.useState(false);
  const [data] = React.useState<IFormData>({
    name: "",
    isPublic: false,
    ...(action && action[0] === "update" ? action[1] : {}),
  });

  const onSubmit = async (value: IFormData) => {
    const data = {
      name: value.name,
      isPublic: value.isPublic,
    };

    setLoading(true);
    try {
      if (action && action[0] === "update") {
        await AdjustmentApi.update(action[1].id, {
          ...data,
        });
      } else {
        await AdjustmentApi.create(data);
      }

      Message.success("Таны хүсэлт амжилттай!");
      onCancel && onCancel();
      reload();
    } catch (err) {
      Message.error((err as HttpHandler)?.message!);
    }
    setLoading(false);
  };

  return (
    <Form validationSchema={schema} onSubmit={onSubmit} initialValues={data}>
      {() => {
        return (
          <FormLayout
            title={action && action[0] === "update" ? "Барааны нөөцийн хөдөлгөөн засварлах" : "Барааны нөөцийн хөдөлгөөн нэмэх"}
            subTitle="Барааны нөөцийн хөдөлгөөн"
            my={0}
            extra={[<CloseButton key="cancel" onClick={() => onCancel && onCancel()} />]}>
            <LoadingOverlay visible={loading} />
            <Flex gap={15} direction="column">
              <Divider />
              <TextField name="name" label="Нэр" placeholder="Нэр" />
              <CheckboxField name="isPublic" label="Нээлттэй" />
              <Divider mb={10} />
            </Flex>
            <Flex justify="space-between">
              <Button key={1} variant="default" onClick={() => onCancel && onCancel()}>
                Болих
              </Button>
              <Button key={2} type="submit">
                Хадгалах
              </Button>
            </Flex>
          </FormLayout>
        );
      }}
    </Form>
  );
}
